import type { IFileWrapper } from "./common/uploader/uploader-helpers";

export interface IDictionary<T> {
  [key: string]: T;
}

export enum MediaSize {
  TH = 320,
}

interface IMediaLockConfigType {
  unlockText?: string | React.ReactNode;
  unlockButtonText?: string;
  unlockData?: IDictionary<unknown>;
}

export interface IMediaType {
  public_id?: string; // cloudinary public id
  media_id?: string; // bendinary media id
  th: string; // width 320px
  st?: string; // width 600px
  rt?: string; // width 1080px
  sr?: string; // width 1440px
  op?: string; // height 320px
  video_url?: string;
  video_length?: number;
  width?: number;
  height?: number;
  approved?: boolean;
  review_status?: string;
  score?: number;
  isLocked?: boolean; // custom
  isClientSideBlur?: boolean; // custom
  caption?: string; // from feed
  lockConfig?: IMediaLockConfigType;
  isClientSide?: boolean; // client side item
  uploadProgress?: number; // client side item
  loaded?: number; // client side item
  total?: number; // client side item
  abortUpload?: () => void; // client side item
}

export enum EPaymentType {
  Subscription = "Subscription",
  PackageSelect = "PackageSelect",
  ChatTip = "ChatTip",
  ChatPurchase = "ChatPurchase",
  FeedTip = "FeedTip",
}

export enum EMessageBubbleType {
  User = "User",
  OtherUser = "OtherUser",
  System = "System",
  SystemWarning = "SystemWarning",
  SystemPaidChatRequested = "SystemPaidChatRequested",
  SystemPaidChatAccepted = "SystemPaidChatAccepted",
  Tip = "Tip",
}

export enum EPaidContentPopupType {
  Messenger = "Messenger",
  AutoMessages = "AutoMessages",
  Broadcast = "Broadcast",
}

export interface IUploadQueue {
  id: string;
  filesToUpload: IFileWrapper[];
  uploadHandler: (mediaFileWrapper: IFileWrapper, callback: () => void) => void;
  onFileComplete?: (mediaFileWrapper: IFileWrapper) => void;
  onQueueComplete?: (id: string) => void;
  description: string;
}
